var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.length > 0)?_c('slider',{staticClass:"feed-widget",attrs:{"items":_vm.items,"config":_vm.config},scopedSlots:_vm._u([{key:"body",fn:function({ item, index }){return [_vm._t("body",null,{"item":item,"index":index})]}}],null,true)},[_vm._v(" "),(_vm.length > 1)?_vm._t("navigation",null,{"slot":"navigation"}):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }